import * as rForm from 'redux-form';
import reducerRegistry from "./reducerRegistry";

const {reduxForm, Form, Field, FieldArray, reducer: form, FormSection, resetSection, clearFields, submit, formValueSelector, reset, change, focus, isInvalid, initialize, updateSyncErrors, registerField, touch, startSubmit} = rForm ;

reducerRegistry.register('form', form);

export {reduxForm, Form, Field, FieldArray, FormSection, resetSection, clearFields, submit, formValueSelector, reset, change, focus, isInvalid, initialize, updateSyncErrors, registerField, touch, startSubmit};